<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <div class="source-arc-info">
    <!-- TODO: Change info related to add/edit -->
    <p>
      {{ 'Collega una fonte con il bene corrente.' | translate }}
    </p>
    <p>
      {{ 'Una volta collegato dovrai salvare le modifiche apportate' | translate }}
    </p>
    <button mat-raised-button color="primary" (click)="handleCreateAndAdd()">Crea nuovo ed aggiungi ad oggetto</button>
  </div>

  <form [formGroup]="sourceArcForm">
    <div class="ui-table-container">
      <ui-table
        [rowSelection]="'single'"
        [fields]="fields"
        [pager]="pager$"
        [reload]="reload$"
        [filters]="filters$ | async"
        [itemsPage]="(page$ | async)?.current"
        [itemsPerPage]="(page$ | async)?.limit"

        [selected]="selectedItems"
        (select)="selectHandler($event)"
        (itemsPageChange)="applyChangePageHandler($event)">
        <div tableFilters>
          <ui-filters
            [dialogFilters]="MobileFiltersComponent"
            (action)="applyFilterWithDelayHandler($event)">
            <app-source-archivial-filters #desktopFilter></app-source-archivial-filters>
          </ui-filters>
        </div>
      </ui-table>
    </div>
    <div class="source-arc-actions">
      <button
        mat-button
        mat-raised-button
        type="button"
        (click)="completeHandler()">
        {{  mainActionLabel }}
      </button>
    </div>
  </form>
</mat-dialog-content>
